import { Navigate  } from 'react-router-dom'

import { getCookie } from './utils/manageCookie'

const PrivateRoute = ({ component }) => {
  const user = getCookie('akive_user')

  return(
    user?.accessToken ? component : <Navigate to='/sign-in'></Navigate>
  )
}

export default PrivateRoute